export default "__VITE_ASSET__CxlvAmHi__"